module.exports = __webpack_public_path__ + "static/card-truckers-2-5615c68890e6860a0598ca4453802101.jpg";